module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-04.c6eb1af5.png";